var map = {
	"./diamond.svg": 1990,
	"./gog.svg": 9981,
	"./modio.svg": 4821,
	"./modiologo.svg": 2583,
	"./modiologoMob.svg": 9932,
	"./oculus.svg": 2106,
	"./sketchfab.svg": 7244,
	"./switch.svg": 5152
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1771;